import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

const useTradePageState = () => {
  const location = useLocation()
  const isLimitMode = location.pathname.includes('limit')
  const isSwapMode = location.pathname.includes('swap')

  const showTabs = /(limit|swap)/.test(
    location.pathname.split('/')?.at(-1) || ''
  )

  return useMemo(
    () => ({
      isSwapMode,
      isLimitMode,
      showTabs,
    }),
    [isLimitMode, isSwapMode, showTabs]
  )
}

export default useTradePageState
